module.exports = __webpack_public_path__ + "img/total-merchant.ab3ed20d.svg";